const blocks = document.querySelectorAll('section.text-and-image');

if(blocks.length > 0) {
  blocks.forEach((block) => {
    const expandableSection = block.querySelector('.expandable-section');
    if(expandableSection) {
      const moreBtn = expandableSection.querySelector('.expand-btn');
      const expandableText = expandableSection.querySelector('.expandable-text');

      moreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        moreBtn.classList.toggle('expanded');
        expandableText.classList.toggle('expanded');
      });
    }
  });
}